module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/shell-1c7805861638c4eadf05028c52a8f7bd.png";